import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Pong.css';

const Pong = () => {
  const [paddle1Y, setPaddle1Y] = useState(150);
  const [paddle2Y, setPaddle2Y] = useState(150);
  const [ball, setBall] = useState({ x: 200, y: 200, dx: 4, dy: 4 });
  const [score, setScore] = useState({ player: 0, ai: 0 });
  const [gameActive, setGameActive] = useState(false);
  const [keys, setKeys] = useState({});
  const animationRef = useRef(null);

  const GAME_WIDTH = 600;
  const GAME_HEIGHT = 400;
  const PADDLE_HEIGHT = 80;
  const PADDLE_WIDTH = 10;
  const BALL_SIZE = 10;
  const PADDLE_SPEED = 6;

  const startGame = () => {
    setGameActive(true);
    setPaddle1Y(150);
    setPaddle2Y(150);
    setBall({ x: 300, y: 200, dx: 4, dy: 4 });
    setScore({ player: 0, ai: 0 });
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      const key = e.key.toLowerCase();
      if (['w', 's', 'arrowup', 'arrowdown'].includes(key)) {
        e.preventDefault();
        setKeys(k => ({ ...k, [key]: true }));
      }
    };

    const handleKeyUp = (e) => {
      const key = e.key.toLowerCase();
      setKeys(k => ({ ...k, [key]: false }));
    };

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
    };
  }, []);

  useEffect(() => {
    if (!gameActive) return;

    const gameLoop = () => {
      if (keys['w'] || keys['arrowup']) {
        setPaddle1Y(y => Math.max(0, y - PADDLE_SPEED));
      }
      if (keys['s'] || keys['arrowdown']) {
        setPaddle1Y(y => Math.min(GAME_HEIGHT - PADDLE_HEIGHT, y + PADDLE_SPEED));
      }

      setPaddle2Y(y => {
        const ballCenter = ball.y + BALL_SIZE / 2;
        const paddleCenter = y + PADDLE_HEIGHT / 2;
        if (ballCenter < paddleCenter - 10) return Math.max(0, y - 3);
        if (ballCenter > paddleCenter + 10) return Math.min(GAME_HEIGHT - PADDLE_HEIGHT, y + 3);
        return y;
      });

      setBall(b => {
        let newBall = { ...b };
        newBall.x += newBall.dx;
        newBall.y += newBall.dy;

        if (newBall.y <= 0 || newBall.y >= GAME_HEIGHT - BALL_SIZE) {
          newBall.dy = -newBall.dy;
        }

        if (newBall.x <= PADDLE_WIDTH && 
            newBall.y + BALL_SIZE >= paddle1Y && 
            newBall.y <= paddle1Y + PADDLE_HEIGHT) {
          newBall.dx = Math.abs(newBall.dx);
          newBall.dy += (Math.random() - 0.5) * 2;
        }

        if (newBall.x >= GAME_WIDTH - PADDLE_WIDTH - BALL_SIZE && 
            newBall.y + BALL_SIZE >= paddle2Y && 
            newBall.y <= paddle2Y + PADDLE_HEIGHT) {
          newBall.dx = -Math.abs(newBall.dx);
          newBall.dy += (Math.random() - 0.5) * 2;
        }

        if (newBall.x < 0) {
          setScore(s => ({ ...s, ai: s.ai + 1 }));
          return { x: 300, y: 200, dx: 4, dy: 4 };
        }

        if (newBall.x > GAME_WIDTH) {
          setScore(s => ({ ...s, player: s.player + 1 }));
          return { x: 300, y: 200, dx: -4, dy: 4 };
        }

        return newBall;
      });

      animationRef.current = requestAnimationFrame(gameLoop);
    };

    animationRef.current = requestAnimationFrame(gameLoop);
    return () => cancelAnimationFrame(animationRef.current);
  }, [gameActive, keys, paddle1Y, paddle2Y, ball]);

  return (
    <div className="game-container">
      <div className="game-header">
        <h1 className="game-title-header">🏓 Pong</h1>
        <div className="game-instructions">
          Use W/S or ↑/↓ to move your paddle
        </div>
      </div>

      <div className="game-board">
        <div className="score-display">
          Player: {score.player} | AI: {score.ai}
        </div>
        
        <div className="game-play-area">
          <div className="pong-game-area">
            <div className="paddle paddle-left" style={{ top: paddle1Y }} />
            <div className="paddle paddle-right" style={{ top: paddle2Y }} />
            <div className="pong-ball" style={{ left: ball.x, top: ball.y }} />
            <div className="center-line" />

            {!gameActive && (
              <div className="game-status-overlay">
                <div className="status-message start">Press Start to Play!</div>
              </div>
            )}
          </div>
        </div>

        <div className="game-controls">
          <button className="btn btn-primary" onClick={startGame}>
            {gameActive ? 'Restart' : 'Start Game'}
          </button>
          <Link to="/" className="btn btn-secondary">Back to Home</Link>
        </div>
      </div>
    </div>
  );
};

export default Pong;
